import type { BancoModel } from "../../../services/dadosBancariosSubconta"

export type DadosBancariosSubcontaModel = {
    id: number | null
    dataPersonType: number | null
    nomeEmpresa: string
    telefone: string
    endereco: string
    estado: string
    cidade: string
    cep: string
    responsavelName: string
    responsavelCpf: string
    cpfCnpj: string
    nomeBanco: string
    agencia: string
    numeroConta: string
    tipoConta: string
    operacao: string
    possuiTokensCriadosIugu: boolean
    possuiDadosBancariosCompletos: boolean
    nomeEstabelecimento: string
    bancos: BancoModel[]
}

export const DadosBancariosSubcontaInicial: DadosBancariosSubcontaModel = {
    id: null,
    dataPersonType: null,
    nomeEmpresa: "",
    telefone: "",
    endereco: "",
    estado: "",
    cidade: "",
    cep: "",
    responsavelName: "",
    responsavelCpf: "",
    cpfCnpj: "",
    nomeBanco: "",
    agencia: "",
    numeroConta: "",
    tipoConta: "",
    operacao: "",
    possuiTokensCriadosIugu: false,
    possuiDadosBancariosCompletos: false,
    nomeEstabelecimento: "",
    bancos: [],
}
